import { BybListItem, BybListItemSkeleton, BybSection, BybSectionHeader } from "@Components/common/byb-ds";
import { GridImageCard } from "@Components/game/cards/styled-components";
import { BybButtonVR } from "@Components/game/common";
import useI18n from "@i18n";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import CalendarIcon from "@Resources/app/icons-v2/system-icons/calendar-icon";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import dayjs from "dayjs";

interface PlaylistDescriptionProps {
  playlist: PlaylistResponse | null | undefined;
  startSession: () => void;
  loading: boolean;
}

const PlaylistDescription = ({ playlist, startSession, loading }: PlaylistDescriptionProps) => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const scenarioCount = playlist?.scenario_count ?? 0;

  return (
    <GridImageCard sx={{ display: "flex", flexDirection: "column", borderRadius: theme.spacing(0, 0, 2, 2), flexGrow: 1 }}>
      <Stack direction="row" textAlign={"center"} alignItems={"center"} padding={theme.spacing(0, 2.5)} spacing={3.5}>
        <Box padding={theme.spacing(4, 0)} width={"40%"}>
          <BybSectionHeader title={playlist?.name} subTitle={!loading ? i18n("playlist.scenarios.amount", { count: scenarioCount }) : ""} />
        </Box>
        <Box padding={theme.spacing(1, 0)} width={"60%"}>
          {playlist ? (
            <BybListItem header={dayjs(new Date(playlist?.created_at)).format("D MMM YYYY")} icon={<CalendarIcon />} />
          ) : (
            <BybListItemSkeleton avatar />
          )}
        </Box>
      </Stack>
      <BybSection
        title={i18n("playlists.playlist.page.description")}
        sx={{
          background: "transparent",
        }}
      >
        <Box padding={theme.spacing(1.25, 2.5)}>
          {playlist ? (
            <Typography variant="textBase400" whiteSpace="pre-wrap" color="base.v200">
              {playlist.description}
            </Typography>
          ) : (
            <Skeleton variant="rounded" width="100%" height={theme.spacing(12)} />
          )}
        </Box>
      </BybSection>
      <Stack sx={{ flexGrow: 1, justifyContent: "center", alignItems: "center", padding: 8 }}>
        <BybButtonVR onClick={startSession} sx={{ padding: theme.spacing(2.5, 8) }}>
          {i18n("button.start")}
        </BybButtonVR>
      </Stack>
    </GridImageCard>
  );
};

export default PlaylistDescription;
